import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const securityEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-security-entrypoint" */ './src/ui/index.tsx'),
	),
	getPreloadProps: () => ({}),
});
